<div class="report-container">
	<div class="options-container">
		@if (showOptions()) {
			<!-- View Selection -->
			<div class="view-selector-container">
				<mat-form-field appearance="outline" class="view-selector">
					<mat-label>Base view</mat-label>
					<mat-select
						[value]="view()"
						(selectionChange)="view.set($event.value)"
					>
						@for (staticView of staticViews(); track $index) {
							<mat-option [value]="staticView">{{
								staticView.description
							}}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-button-toggle-group
					[ngModel]="viewType()"
					(ngModelChange)="viewType.set($event)"
				>
					@for (viewTypeOption of viewTypeOptions; track $index) {
						<mat-button-toggle [value]="viewTypeOption[0]">{{
							viewTypeOption[1]
						}}</mat-button-toggle>
					}
				</mat-button-toggle-group>
				<div class="spacer"></div>
				<span>
					<button matButton (click)="openExportDialog()">
						<mat-icon>download</mat-icon>
						Export
					</button>
				</span>
			</div>
		}
	</div>
	@if (showOptions()) {
		<!-- Pivot Table Configuration -->
		<mat-expansion-panel class="pivot-config-panel">
			<mat-expansion-panel-header>
				<mat-panel-title>Pivot Table Configuration</mat-panel-title>
			</mat-expansion-panel-header>

			<div class="pivot-config-content">
				<!-- Available Columns -->
				<mat-card class="pivot-section">
					<mat-card-header>
						<mat-card-title>Available Columns</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div
							cdkDropList
							#availableCols="cdkDropList"
							[cdkDropListData]="availableColumns()"
							[cdkDropListConnectedTo]="[
								filtersList,
								groupByList,
								aggregationsList,
							]"
							class="column-list"
						>
							@for (column of availableColumns(); track column) {
								<div class="column-chip" cdkDrag>
									<mat-icon cdkDragHandle class="drag-handle"
										>drag_indicator</mat-icon
									>
									<span>{{ column }}</span>
								</div>
							}
						</div>
					</mat-card-content>
				</mat-card>

				<!-- Filters -->
				<mat-card class="pivot-section">
					<mat-card-header>
						<mat-card-title>Filters</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div
							cdkDropList
							#filtersList="cdkDropList"
							[cdkDropListData]="options().filters"
							(cdkDropListDropped)="dropFilter($event)"
							class="filter-list"
							[cdkDropListConnectedTo]="[availableCols]"
						>
							@for (
								filter of options().filters;
								track $index;
								let filterIndex = $index
							) {
								<div class="filter-item" cdkDrag>
									<mat-icon cdkDragHandle class="drag-handle"
										>drag_indicator</mat-icon
									>
									<div class="filter-controls">
										<mat-form-field
											appearance="outline"
											class="filter-property"
										>
											<mat-label>Property</mat-label>
											<input matInput [value]="filter.property" readonly />
										</mat-form-field>
										<mat-form-field
											appearance="outline"
											class="filter-operator"
										>
											<mat-label>Operator</mat-label>
											<mat-select
												[value]="filter.operator"
												(selectionChange)="
													updateFilterOperator(filterIndex, $event.value)
												"
											>
												@for (op of filterOperators; track op) {
													<mat-option [value]="op">{{ op }}</mat-option>
												}
											</mat-select>
										</mat-form-field>
										@if (
											filter.operator !== 'is null' &&
											filter.operator !== 'is not null'
										) {
											<mat-form-field appearance="outline" class="filter-value">
												<mat-label>Value</mat-label>
												@for (
													value of filter.values;
													track $index;
													let valueIndex = $index
												) {
													@if (
														filter.operator === 'in' ||
														filter.operator === 'not in' ||
														filter.operator === 'between' ||
														filter.operator === 'not between'
													) {
														<input
															matInput
															[value]="formatArrayValue(value)"
															(blur)="
																updateFilterValue(
																	filterIndex,
																	valueIndex,
																	parseArrayValue($any($event.target).value)
																)
															"
															placeholder="Comma-separated values"
														/>
													} @else {
														<input
															matInput
															[value]="value"
															(blur)="
																updateFilterValue(
																	filterIndex,
																	valueIndex,
																	$any($event.target).value
																)
															"
														/>
													}
												}
											</mat-form-field>
										}
										<button
											mat-icon-button
											(click)="removeFilter(filterIndex)"
											color="warn"
										>
											<mat-icon>delete</mat-icon>
										</button>
									</div>
								</div>
							}
							@if (options().filters.length === 0) {
								<div class="drop-zone-hint">
									Drag columns here to add filters
								</div>
							}
						</div>
					</mat-card-content>
				</mat-card>

				<!-- Group By -->
				<mat-card class="pivot-section">
					<mat-card-header>
						<mat-card-title>Group By</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div
							cdkDropList
							#groupByList="cdkDropList"
							[cdkDropListData]="options().groupBy"
							(cdkDropListDropped)="dropGroupBy($event)"
							class="groupby-list"
							[cdkDropListConnectedTo]="[availableCols]"
						>
							@for (group of options().groupBy; track group; let i = $index) {
								<div class="groupby-chip" cdkDrag>
									<mat-icon cdkDragHandle class="drag-handle"
										>drag_indicator</mat-icon
									>
									<span>{{ group }}</span>
									<button
										mat-icon-button
										(click)="removeGroupBy(i)"
										color="warn"
										class="remove-btn"
									>
										<mat-icon>close</mat-icon>
									</button>
								</div>
							}
							@if (options().groupBy.length === 0) {
								<div class="drop-zone-hint">Drag columns here to group by</div>
							}
						</div>
					</mat-card-content>
				</mat-card>

				<!-- Aggregations -->
				<mat-card class="pivot-section">
					<mat-card-header>
						<mat-card-title>Aggregations</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div
							cdkDropList
							#aggregationsList="cdkDropList"
							[cdkDropListData]="options().aggregations"
							(cdkDropListDropped)="dropAggregation($event)"
							class="aggregation-list"
							[cdkDropListConnectedTo]="[availableCols]"
						>
							@for (
								agg of options().aggregations;
								track $index;
								let i = $index
							) {
								<div class="aggregation-item" cdkDrag>
									<mat-icon cdkDragHandle class="drag-handle"
										>drag_indicator</mat-icon
									>
									<div class="aggregation-controls">
										<mat-form-field appearance="outline" class="agg-property">
											<mat-label>Property</mat-label>
											<input matInput [value]="agg.property" readonly />
										</mat-form-field>
										<mat-form-field appearance="outline" class="agg-operator">
											<mat-label>Operator</mat-label>
											<mat-select
												[value]="agg.operator"
												(selectionChange)="
													updateAggregationOperator(i, $event.value)
												"
											>
												@for (op of aggregationOperators; track op) {
													<mat-option [value]="op">{{ op }}</mat-option>
												}
											</mat-select>
										</mat-form-field>
										<mat-form-field appearance="outline" class="agg-output">
											<mat-label>Output Name</mat-label>
											<input
												matInput
												[value]="agg.outputName || ''"
												(blur)="
													updateAggregationOutputName(
														i,
														$any($event.target).value
													)
												"
											/>
										</mat-form-field>
										<button
											mat-icon-button
											(click)="removeAggregation(i)"
											color="warn"
										>
											<mat-icon>delete</mat-icon>
										</button>
									</div>
								</div>
							}
							@if (options().aggregations.length === 0) {
								<div class="drop-zone-hint">
									Drag columns here to add aggregations
								</div>
							}
						</div>
					</mat-card-content>
				</mat-card>
			</div>
		</mat-expansion-panel>
	}

	<!-- Results Table -->
	@switch (viewType()) {
		@case ('drillDownChart') {
			<mat-label>Drilldown Filters</mat-label>
			<lowgile-chevron>
				<div lowgile-chevron-step [isBeginning]="true">
					<span
						(click)="removeDrilldownFiltersAfter(-1)"
						[class.drilldown-filter-clickable]="drilldownFilters().length"
						>All</span
					>
				</div>
				@for (filter of drilldownFilters(); track filter; let last = $last) {
					<div
						lowgile-chevron-step
						[class.drilldown-filter-inactive]="!filter.isActive"
					>
						<span
							(click)="removeDrilldownFiltersAfter($index)"
							[class.drilldown-filter-clickable]="!last"
							>{{ filter.property }}:
							{{ getDrilldownFilterDisplayString(filter) }}</span
						>
						<button
							mat-icon-button
							mat-tiny-icon-button
							(click)="removeDrilldownFilter($index)"
						>
							<mat-icon>close</mat-icon>
						</button>
						<button
							mat-icon-button
							mat-tiny-icon-button
							(click)="toggleDrilldownFilterActive($index)"
						>
							<mat-icon>{{
								filter.isActive ? 'toggle_on' : 'toggle_off'
							}}</mat-icon>
						</button>
					</div>
				}
			</lowgile-chevron>

			<div class="chart-container">
				@for (config of drilldownChartConfigurations(); track config) {
					<div class="chart">
						<!-- <small>{{ config | json }}</small> -->
						<canvas
							baseChart
							[data]="config.data"
							[type]="config.type"
							[options]="config.options"
							height="400"
						></canvas>
					</div>
				}
			</div>
		}
		@case ('aggregated') {
			<mat-label>Group By</mat-label>
			<mat-chip-set
				cdkDropList
				(cdkDropListDropped)="reorderAvailableGroupBy($any($event))"
				cdkDropListOrientation="horizontal"
				class="groupby-list"
			>
				@for (group of availableGroupBy(); track group; let i = $index) {
					<mat-chip
						cdkDrag
						[class.inactive-groupby-chip]="disabledGroupBys().has(group)"
						(click)="toggleDisabledGroupBy(group)"
						>{{ group }}</mat-chip
					>
				}
			</mat-chip-set>
		}
	}
	@if (results.hasValue()) {
		<table
			mat-table
			[dataSource]="rows()"
			class="mat-elevation-z8 results-table"
			multiTemplateDataRows
		>
			@for (column of displayedColumns(); track $index) {
				<ng-container [matColumnDef]="column.property">
					<th
						mat-header-cell
						*matHeaderCellDef
						(click)="sortColumn(column.property, $event)"
						class="sortable-header"
						[class.sorted-asc]="getSortDirection(column.property) === 'ASC'"
						[class.sorted-desc]="getSortDirection(column.property) === 'DESC'"
					>
						<span class="header-content">
							{{ column.displayName }}
							@if (getSortDirection(column.property)) {
								<mat-icon class="sort-icon">
									{{
										getSortDirection(column.property) === 'ASC'
											? 'arrow_upward'
											: 'arrow_downward'
									}}
								</mat-icon>
							} @else {
								<mat-icon class="sort-icon sort-icon-inactive"
									>unfold_more</mat-icon
								>
							}
						</span>
					</th>
					<td
						mat-cell
						*matCellDef="let row"
						(contextmenu)="onCellContextMenu($event, column, row)"
					>
						{{ row[column.property] }}
					</td>
				</ng-container>
			}

			<ng-container matColumnDef="$expand">
				<th mat-header-cell *matHeaderCellDef></th>
				<td mat-cell *matCellDef="let row" style="width: 50px">
					<button
						mat-icon-button
						mat-small-icon-button
						(click)="toggleExpandRow(row)"
					>
						<mat-icon>{{
							expandedRows().has(row) ? 'expand_less' : 'expand_more'
						}}</mat-icon>
					</button>
				</td>
			</ng-container>
			<ng-container matColumnDef="$details">
				<td
					mat-cell
					*matCellDef="let row"
					[attr.colspan]="displayedColumnProperties().length"
				>
					@if (expandedRows().has(row)) {
						<app-report
							[report]="report()"
							[view]="view()?.name"
							[options]="getRowDetailOptions(row)"
							[showOptions]="false"
							viewType="fullData"
						></app-report>
					}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumnProperties()"></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayedColumnProperties()"
			></tr>
			@if (viewType() !== 'fullData') {
				<tr
					mat-row
					*matRowDef="let row; columns: ['$details']"
					[hidden]="!expandedRows().has(row)"
				></tr>
			}
		</table>

		<mat-paginator
			[length]="paginationLength()"
			[pageSize]="paginationPageSize()"
			[pageSizeOptions]="paginationPageSizeOptions"
			[pageIndex]="paginationPageIndex()"
			(page)="onPage($event)"
		></mat-paginator>

		<div
			#cellContextMenuTrigger="matMenuTrigger"
			[matMenuTriggerFor]="cellContextMenu"
		></div>
		<mat-menu #cellContextMenu>
			<ng-template matMenuContent let-column="column" let-row="row">
				<button
					mat-menu-item
					(click)="
						addDrilldownFilter(
							column.property,
							row[column.property],
							true,
							false
						)
					"
				>
					Filter for this value
				</button>
				<button
					mat-menu-item
					(click)="
						addDrilldownFilter(
							column.property,
							row[column.property],
							true,
							true
						)
					"
				>
					Exclude this value
				</button>
			</ng-template>
		</mat-menu>
	}
</div>
